class tags {
  constructor(id, text, descripcion, color, scope) {
    this.id = id;
    this.text = text;
    this.description = descripcion;
    this.color = color;
    this.scope = scope;
  }
  static fromJson({ etiquetaId, nombre, descripcion, color, alcance }) {
    return new tags(etiquetaId, nombre, descripcion, color, alcance);
  }
}
export default tags;
